/**
 * Tema da lib @ficatranquilo/contabilidade.com-ui com a ação do OneWork.
 * Só os papéis de cor da lib (ACTION, FOCUS…) mudam: apontam para as vars
 * --ow-*, que o applyTenantTheme() troca pela cor da empresa. A paleta fica a
 * da lib, então o verde de sucesso (P*) e as semânticas (E*, A*, T*) não mudam.
 */
import { THEME } from "@ficatranquilo/contabilidade.com-ui";

export const OW_LIB_ROLES = {
  ACTION: "var(--ow-primary)",
  ACTION_HOVER: "var(--ow-primary-hover)",
  ACTION_SUBTLE: "var(--ow-primary-50)",
  ON_ACTION: "var(--ow-on-primary)",
  FOCUS: "var(--ow-focus-ring-color)",
  FIELD_FOCUS: "var(--ow-primary)",
};

export const LIB_THEME = {
  ...THEME,
  colors: { ...THEME.colors, ...OW_LIB_ROLES },
};

export default LIB_THEME;
